import { createContext } from 'react'

const submitContext = createContext()

export default submitContext
